// Report only after the page has successfully applied its main data.
export function reportPageDataUpdated(page, updatedAt = new Date()) {
  if (page._isDestroyed || page._isBeingDestroyed) return;
  page.$emit("data-updated", { route: page.$route.fullPath, updatedAt });
}
